import React from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import PortfolioSummary from "@/PortfolioSummary/index"
import ErrorBoundary from "@/ErrorBoundary"
import { TooltipProvider } from "~/components/ui/Tooltip"

const queryClient = new QueryClient()

interface PortfolioSummaryAppProps {
  year: number
  quarter: number
}

const PortfolioSummaryApp = ({ year, quarter }: PortfolioSummaryAppProps) => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider delayDuration={0}>
      <ErrorBoundary>
        <PortfolioSummary year={year} quarter={quarter} />
      </ErrorBoundary>
    </TooltipProvider>
  </QueryClientProvider>
)

export default PortfolioSummaryApp
